<template>
  <div class="pages">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <div class="popup">
      <div class="closeIcon" @click="closeHandleFormol"></div>
      <div class="title">Choose a Gen2 Yuliuide for Staking</div>
      <div class="contentView">
        <div class="chooseView" v-if="!!yuliGroupList?.length">
          <div
            class="item"
            @click="handleYuliClick(item)"
            v-for="(item, index) in yuliGroupList"
            :key="index"
          >
            <div class="bg"></div>
            <div class="top">
              <div class="left">
                <div class="id">#{{ item?.token_id || "" }}</div>
                <div class="level">Lv.{{ item?.level || 1 }}</div>
              </div>
              <div class="right">
                <img
                  class="tag"
                  :src="
                    require(`@/assets/images/YuliApp/common/Yuli/type/${item?.role_type_name}.png`)
                  "
                  v-if="item?.role_type_name"
                />
                <img
                  class="tag"
                  :src="
                    require(`@/assets/images/YuliApp/common/Yuli/property/icon_${item?.role_property_name}.png`)
                  "
                  v-if="item?.role_property_name"
                />
              </div>
            </div>
            <img class="yuli" :src="item?.image" v-if="item?.image" />
            <div class="bottom">
              <div class="row">
                <div class="num">
                  {{ item?.passcardMap?.[TIMETYPE.days60] || 0 }}
                </div>
                <div class="text">{{ `Passcard / 60 Days` }}</div>
              </div>
              <div
                class="row"
                :style="{
                  justifyContent: '',
                  flexDirection: 'column',
                }"
              >
                <div class="row">
                  <div class="num">
                    {{ item?.artMap?.[item?.level] || 0 }}
                  </div>
                  <div class="text">{{ `ART/Day` }}</div>
                </div>
                <div class="row">
                  <div class="num">375</div>
                  <div class="text">{{ `EXP/Day` }}</div>
                </div>
              </div>
            </div>

            <!-- 禁用状态 -->
            <div
              class="item-disable"
              v-if="item?.is_on_team || item?.is_on_market"
            >
              <div class="item-disable-decorate"></div>
              <div
                class="item-disable-text"
                v-if="item?.is_on_team && !item?.is_on_market"
              >
                Purifying
              </div>
              <div
                class="item-disable-text"
                v-if="item?.is_on_market && !item?.is_on_team"
              >
                Listed in Marketplace
              </div>
              <div
                :class="['item-disable-text', 'item-disable-text-both']"
                v-if="item?.is_on_market && item?.is_on_team"
              >
                Purifying <br />
                Listed in Marketplace
              </div>
            </div>
          </div>
        </div>

        <div class="nodata" v-if="yuliGroupList?.length === 0">
          <div v-if="!isLoading">
            <img
              class="icon"
              :src="
                require('@/assets/images/YuliApp/YuliStaking/icon_nodata.png')
              "
            />
            <div class="desc">Sorry, you don't have Gen2 Yuli currently</div>
          </div>
          <div v-if="isLoading">
            <div class="loading"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onMounted, ref } from "vue";
import { getYuliList } from "@/api/staking.js";
import { checkIsGen2 } from "@/utils/yuli.js";
import {
  YULI_ROLE_TYPE_MAP,
  YULI_ROLE_PROPERTY_TYPE_MAP,
  TIME_TYPE,
} from "../../../../constants/type.js";
import {
  PASSCARD_INCOME_MAP,
  ART_INCOME_MAP,
} from "../../../../constants/incomeMap.js";
import { CHIAN_TYPE } from "@/constants/chains.js";
import { YULI_GEN2_MARKET_CENTER } from "@/constants/address.js";
import yuli_gen2_market_center_contract from "@/constants/abi/yuli_gen2_market_center_contract";
import { getHttpProviderByChain, getContractByWeb3 } from "@/utils/contract.js";

export default {
  props: {},
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(prop, { emit }) {
    const yuliGroupMap = ref({});
    const yuliGroupList = ref([]);
    const isLoading = ref(false);

    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const TIMETYPE = ref(TIME_TYPE);

    onMounted(() => {
      handleGetYuliList();
    });

    /**
     * 获取二代Yuli列表
     */
    const handleGetYuliList = async () => {
      isLoading.value = true;

      const res = await getYuliList();
      const data = res?.data || [];
      // 过滤二级Yuli
      const _gen2_yuli = data.filter((item) => {
        const token_id = Number(item?.token_id || "");
        const is_free_role = item?.is_free_role;
        const is_on_staking = item?.extension?.is_on_staking;
        return checkIsGen2(token_id) && !is_free_role && !is_on_staking;
      });
      // 数据转换
      const _gen2_yuli_list = [];
      for (const i in _gen2_yuli) {
        const item = _gen2_yuli[i];
        const extension = item.extension;
        const role_type = extension?.role_type;
        const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
        const role_property = extension?.role_property;
        const role_property_name = YULI_ROLE_TYPE_MAP[role_property] || "";
        const token_id = item?.token_id;
        const is_listed = await handleGetYuliIsList(token_id);

        _gen2_yuli_list.push({
          ...item,
          ...extension,
          role_type_name,
          role_property_name,
          passcardMap: PASSCARD_INCOME_MAP?.[role_type_name] || {},
          artMap: ART_INCOME_MAP?.[role_type_name] || {},
          is_on_market: is_listed,
        });
      }
      yuliGroupList.value = _gen2_yuli_list || [];

      isLoading.value = false;
    };

    /**
     * 处理关闭
     */
    const closeHandleFormol = () => {
      emit("onClose");
    };

    /**
     * 处理Yuli选择
     */
    const handleYuliClick = (item) => {
      if (item?.is_on_team || item?.is_on_market) {
        return;
      }

      emit("onSelect", item);
    };

    const handleGetContract = async () => {
      try {
        const chain = CHIAN_TYPE.BSC;
        const address = YULI_GEN2_MARKET_CENTER;
        const abi = yuli_gen2_market_center_contract;
        const provider = getHttpProviderByChain(chain);
        const contract = await getContractByWeb3(provider, address, abi);
        return contract;
      } catch (error) {
        return null;
      }
    };

    const handleGetYuliIsList = async (token_id) => {
      try {
        if (!token_id) return false;
        const contract = await handleGetContract();
        let res = (await contract?.methods.isListed(token_id).call()) || false;

        if (!res) return false;

        // 通过时间判断是否过期
        const list_info =
          (await contract?.methods.getListedNFT(token_id).call()) || null;

        const expirationTime = list_info["expirationTime"] || 0;
        const timestamp = expirationTime * 1000;
        const nowadays = new Date().getTime();
        const _diff_time = timestamp - nowadays;
        res = _diff_time > 0;
        return res;
      } catch (error) {
        return false;
      }
    };

    return {
      localesPackage,
      localesEnv,
      yuliGroupList,
      yuliGroupMap,
      isLoading,
      TIMETYPE,
      closeHandleFormol,
      handleYuliClick,
    };
  },
};
</script>

<style lang="less" scoped>
.pages {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(7.5px);
    top: 0;
    left: 0;
    animation: maskFade 0.1s ease-in-out;

    @keyframes maskFade {
      0% {
        background: rgba(0, 0, 0, 0);
      }
      100% {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .popup {
    position: relative;
    width: 355px;
    height: 390px;
    opacity: 1;
    background-image: url("~@/assets/images/YuliApp/YuliStaking/choose_popup_bg.png");
    background-size: 100% 100%;
    color: rgb(255, 255, 255);
    font-family: "Inter";
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .closeIcon {
      position: absolute;
      height: 30px;
      width: 30px;
      top: 5px;
      right: 5px;
      // cursor: pointer;
    }

    .title {
      margin-top: 29px;
      color: #ffffff;
      font-family: "Inter";
      font-size: 18px;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
    }

    .contentView {
      width: 100%;
      height: 100%;
      margin-top: 20px;
      margin-bottom: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;

      .chooseView {
        width: 325px;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        .item {
          width: 160px;
          height: 254px;
          margin-right: 5px;
          margin-bottom: 5px;
          border-radius: 1.15px;
          position: relative;

          &:hover {
            .hoverEl {
              display: none;
            }
          }

          &:nth-child(2n) {
            margin-right: 0px;
          }

          .top {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 4px 5px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            box-sizing: border-box;

            .left {
              color: #7bd7ff;
              font-family: "Inter";
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              text-align: left;

              .id {
                margin-bottom: 3px;
              }

              .level {
                font-size: 12px;
              }
            }

            .right {
              display: flex;

              .tag {
                width: 18px;
                height: 18px;
                margin-right: 3px;

                &:last-child {
                  margin-right: unset;
                }
              }
            }
          }

          .bottom {
            position: absolute;
            z-index: 2;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 67px;
            background: #0497b7;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-family: "Inter";
            font-style: normal;
            line-height: normal;
            padding: 6px 8px;
            box-sizing: border-box;

            .row {
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 2px;

              &:last-child {
                margin-bottom: unset;
              }
            }
            .num {
              font-size: 13px;
              font-weight: 700;
              margin-right: 4px;
            }
            .text {
              font-size: 10px;
              font-weight: 400;
              opacity: 0.8;
            }
          }

          .yuli {
            position: absolute;
            width: 170px;
            height: 170px;
            top: 17px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 2;
          }

          .bg {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, #3672aa 0%, #2ae0d5 100%);
          }

          .hoverEl {
            display: none;
            width: 190px;
            height: 235px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: linear-gradient(180deg, #ffffff 0%, #00fff0 100%);
            z-index: 0;
          }

          &-disable {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            opacity: 0.7;
            background: #0e3546;
            z-index: 2;

            &-decorate {
              width: 122px;
              height: 122px;
              background-image: url("~@/assets/images/YuliApp/YuliStaking/yuli_disable_decorate.png");
              background-position: center;
              background-size: 100% 100%;
              position: absolute;
              top: 53px;
              left: 0px;
              right: 0px;
              margin: auto;
            }

            &-text {
              color: #fff06c;
              text-align: center;
              font-family: "Inter";
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 14px;
              position: absolute;
              top: 111px;
              left: 0px;
              right: 0px;
              margin: auto;

              &-both {
                line-height: 16px;
                top: 102px;
                font-size: 12px;
              }
            }
          }
        }
      }

      .nodata {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 78px;

        .icon {
          width: 94px;
          height: 94px;
          margin-bottom: 28px;
        }

        .desc {
          color: #aae1ff;
          font-family: "Inter";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
        }

        .loading {
          width: 40px;
          height: 40px;
          background-image: url("~@/assets/images/YuliApp/common/loading/icon_loading.png");
          background-size: 100% 100%;
          background-position: center;
          animation: rotate 1s linear infinite;

          @keyframes rotate {
            from {
              transform-origin: center center;
              transform: rotate(0deg);
            }
            to {
              transform-origin: center center;
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }
}
</style>
